export default {
  styleOverrides: {
    root: {
      gap: 16,
      alignItems: 'center',
    },
  },
};
